// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".required[data-v-0ec86ef6]:after{content:\" *\";color:red}", ""]);
// Exports
module.exports = exports;
